<template>
    <router-link class="flex items-center link ph3 white hover-bg-near-black pointer" :to="link">
        <h6><slot></slot></h6>
    </router-link>
</template>

<script>
export default {
    props: {
        link: {
            type: String,
            required: true
        }
    }
};
</script>
